import type { CutierLead } from '../../store/useCutierStore';

/** Erster Abrechnungsmonat — davor gibt es keine Cutier-Leads. */
export const CUTIER_FIRST_MONTH_KEY = '2026-08';

/** Firestore-Dokument-ID: ein Kunde pro Monat, mehrere Bestellungen über orderCount. */
export const cutierLeadDocId = (monthKey: string, email: string): string =>
  `${monthKey}__${email.toLowerCase().trim()}`;

export const sumLeadUnits = (leads: CutierLead[]): number =>
  leads.reduce((sum, lead) => sum + (lead.orderCount > 0 ? lead.orderCount : 1), 0);
